import { render, staticRenderFns } from "./ImportTieredPrice.vue?vue&type=template&id=e81527a4&"
import script from "./ImportTieredPrice.vue?vue&type=script&lang=js&"
export * from "./ImportTieredPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e81527a4')) {
      api.createRecord('e81527a4', component.options)
    } else {
      api.reload('e81527a4', component.options)
    }
    module.hot.accept("./ImportTieredPrice.vue?vue&type=template&id=e81527a4&", function () {
      api.rerender('e81527a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/import-tiered-price/ImportTieredPrice.vue"
export default component.exports